
import { useLookupUsersQuery } from "../../stores/OkOkStore";
import type { User } from "../../types/Users";
import ProfilListItem from "../Common/ProfilListItem";
import { useTrads } from "../../contexts/trads/useTrads";


function UserManagers({managers,clickHandler}:{managers:number[],clickHandler?:React.Dispatch<React.SetStateAction<number[]>>}){
    const { data, error, isLoading } = useLookupUsersQuery({'r':{'rangacces':"UM"}});
    const {translate}=useTrads();
    
    const onAddUser = function(event:React.SyntheticEvent<HTMLLIElement>){
        event.preventDefault();
        const usr:number=(event.currentTarget.dataset.id)?parseInt(event.currentTarget.dataset.id):0;
        if(clickHandler){
            clickHandler([...managers,usr]);
        }
    }

    const onRemoveUser = function(event:React.SyntheticEvent<HTMLLIElement>){
        event.preventDefault();
        const usr:number=(event.currentTarget.dataset.id)?parseInt(event.currentTarget.dataset.id):0;
        if(clickHandler){
            clickHandler(managers.filter(e=>e!=usr));
        }
    }

    return (
            error ? (
                <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>
            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : data ? (
                <>
                <div className="userSelector row">
                    <div className="col-6">
                    <div className="card enabled">
                        <div className="card-header">
                            {translate('user_manager_active')}
                        </div>
                        <ul className="list-group  list-group-flush" >
                            {managers.map(e=>(
                                <li className="list-group-item"  onClick={onRemoveUser}  key={e} data-id={e}>
                                    <ProfilListItem userid={e} />
                                </li>
                            ))}
                        </ul>
                    </div>
                    </div>
                    <div className="col-6">
                    <div  className="card dispo">
                        <div className="card-header">
                            {translate('user_manager_disponible')}
                        </div>
                        <ul  className="list-group  list-group-flush">
                            {data.data.map((user:User)=>(
                                !managers.includes(user.id)?
                                <li className="list-group-item" onClick={onAddUser} key={user.id} data-id={user.id}>
                                    {user.nom} {user.prenom} {user.identifiant}
                                </li>
                                :null
                            ))}
                        </ul>
                    </div>
                    </div>            
                </div>
                </>
            ):null
    );
}
export default UserManagers;